import type { ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { Link as LinkBase } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	type?: keyof Omit<typeof helpers.color, 'status'>
	label: ReactNode
}

export const solidStyling = css<Props>`
	color: ${helpers.color.actionLabel};
	background-color: ${helpers.color.action};
	-webkit-font-smoothing: antialiased;
	font: ${helpers.fonts.button};
	border-radius: 4px;
	height: 36px;
	padding: ${helpers.spacing.small} ${helpers.spacing.large};
	transition: color 0.2s, background-color 0.2s;
	white-space: nowrap;
	text-align: center;

	&:is(:focus-visible, :hover) {
		background-color: ${helpers.color.actionHover};
		text-decoration: none;
		color: ${helpers.color.actionLabel};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:disabled {
		background-color: ${helpers.color.actionDisabled};
		color: ${helpers.color.actionDisabledLabel};
	}
`

export const LinkSolid = styled(LinkBase).attrs<Props>(({ label }) => ({
	children: label,
}))<Props>`
	${solidStyling};
`
